import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconVerifiedUser.tsx
const OutlinedFilledVerifiedUser = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m436-348 236-236-50-49-183 183-102-101-51 51 150 152Zm43.94 293Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Z" })
});
const OutlinedVerifiedUser = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m436-339 236-236-50-49-183 183-102-101-51 51 150 152Zm43.94 284Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Zm.06-96q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z" })
});
const RoundedFilledVerifiedUser = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m439-450-76-76q-10-10-25.5-10T311-525q-10 10-10 25t10 26l91 92q14 15 34 15t34-15l177-177q11-10 11-25t-11-25q-10-10-25.5-9.5T597-608L439-450Zm41 390q-8 0-15.5-1.5T450-66q-144-47-229.5-177.5T135-523v-189q0-30 16.5-55t44.5-35l251-94q16-6 33-6t33 6l251 94q28 10 45 35t17 55v189q0 149-86 279.5T510-66q-7 3-14.5 4.5T480-60Z" })
});
const RoundedVerifiedUser = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m439-441-76-76q-10-10-25.5-10T311-516.11q-10 10.37-10 25.07 0 14.71 10 26.04l91 92q14.73 15 34.36 15Q456-358 470-373l177-177q11-10.67 11-25.33Q658-590 647.5-600q-10.5-10-25.7-9.5T597-599L439-441Zm41 381q-8.32 0-15.88-1.5Q456.56-63 450-66q-144-47-229.5-177.6Q135-374.19 135-523.11V-712q0-30.26 16.38-55.16Q167.75-792.07 196-802l251-94q16-6 33-6t33 6l251 94q28.25 9.93 45.13 34.84Q826-742.26 826-712v188.89q0 148.92-86 279.51Q654-113 510-66q-6.56 3-14.12 4.5T480-60Zm0-91q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z" })
});
const SharpFilledVerifiedUser = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m436-348 236-236-50-49-183 183-102-101-51 51 150 152Zm43.94 293Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Z" })
});
const SharpVerifiedUser = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m436-339 236-236-50-49-183 183-102-101-51 51 150 152Zm43.94 284Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Zm.06-96q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z" })
});
const componentMap = {
	outlined: OutlinedVerifiedUser,
	"outlined-fill": OutlinedFilledVerifiedUser,
	rounded: RoundedVerifiedUser,
	"rounded-fill": RoundedFilledVerifiedUser,
	sharp: SharpVerifiedUser,
	"sharp-fill": SharpFilledVerifiedUser
};
const IconVerifiedUser = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconVerifiedUser };